<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col
            cols="12">
            Těhotenství
          </v-col>
          <v-col>
            <VRadioWithValidation
              rules="required"
              v-model="pregnancy"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="pt-0 mt-0"
            cols="12">
            <v-row>
              <v-col
                cols="12">
                Využili jste metod asistované reprodukce?
              </v-col>
              <v-col
                cols="auto">
                <VRadioWithValidation
                  :rules="'required'"
                  v-model="form.spontaneousPregnancy.statusAssist"
                  row
                  custom-class="mt-0 pt-0">
                  <v-radio color="blue lighten-1"
                           label="Ano"
                           :value="1" />
                  <v-radio color="blue lighten-1"
                           label="Ne"
                           :value="2" />
                  <v-radio color="blue lighten-1"
                           label="Nechci uvést"
                           :value="4" />
                </VRadioWithValidation>
              </v-col>
              <v-col>
                <VTextFieldWithValidation
                  v-model="form.spontaneousPregnancy.valueAssist"
                  label="Metoda a kolikrát?"
                  mode="lazy"
                  custom-class="mt-0 pt-0"
                  :disabled="form.spontaneousPregnancy.statusAssist != '1'" />
              </v-col>
            </v-row>
          </v-col>
          <template v-if="pregnancy !== 1">
            <v-col
              cols="12">
              Otěhotněla jste spontánně?
            </v-col>
            <v-col
              cols="auto">
              <VRadioWithValidation
                :disabled="pregnancy === 1"
                :rules="pregnancy === true ? 'required' : ''"
                v-model="form.spontaneousPregnancy.status"
                row
                custom-class="mt-0 pt-0">
                <v-radio color="blue lighten-1"
                         label="Ano"
                         :value="2" />
                <v-radio color="blue lighten-1"
                         label="Ne"
                         :value="1" />
                <v-radio color="blue lighten-1"
                         label="Nechci uvést"
                         :value="4" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="auto">
              <VTextFieldWithValidation
                :rules="(form.spontaneousPregnancy.status == '1' ? 'required' : '')
                  || (form.spontaneousPregnancy.status == '2' ? 'required' : '')"
                v-model="form.spontaneousPregnancy.valueTimes"
                label="Kolikrát?"
                mode="lazy"
                custom-class="mt-0 pt-0"
                :disabled="form.spontaneousPregnancy.status != '1' && form.spontaneousPregnancy.status != '2'" />
            </v-col>
          </template>
        </v-row>
        <template v-if="pregnancy !== 1">
          <v-row>
            <v-col
              cols="12">
              Komplikace v těhotenství
            </v-col>
            <v-col
              cols="12">
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Krvácení
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.bleedingStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
                <v-col
                  class="mt-0 pt-0"
                  cols="12">
                  <v-row>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          v
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.bleedingStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.bleedingWeek"
                            label="Zadejte týden"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.bleedingStatus != '1'" />
                        </v-col>
                        <v-col
                          cols="auto"
                          class="pt-1 mt-0">
                          týdnu
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          kolikátého těhotenství
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.bleedingStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.bleedingPregnancyNumber"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.bleedingStatus != '1'" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Předčasný porod
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.prematureStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
                <v-col
                  class="mt-0 pt-0"
                  cols="12">
                  <v-row>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          v
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.prematureStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.prematureWeek"
                            label="Zadejte týden"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.prematureStatus != '1'" />
                        </v-col>
                        <v-col
                          cols="auto"
                          class="pt-1 mt-0">
                          týdnu
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          kolikátého těhotenství
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.prematureStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.prematurePregnancyNumber"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.prematureStatus != '1'" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Vysoký krevní tlak
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.pressureStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
                <v-col
                  class="mt-0 pt-0"
                  cols="12">
                  <v-row>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          v
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.pressureStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.pressureWeek"
                            label="Zadejte týden"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.pressureStatus != '1'" />
                        </v-col>
                        <v-col
                          cols="auto"
                          class="pt-1 mt-0">
                          týdnu
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          kolikátého těhotenství
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.pressureStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.pressurePregnancyNumber"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.pressureStatus != '1'" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Těhotenská cukrovka
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.diabetesStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
                <v-col
                  class="mt-0 pt-0"
                  cols="12">
                  <v-row>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          v
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.diabetesStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.diabetesWeek"
                            label="Zadejte týden"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.diabetesStatus != '1'" />
                        </v-col>
                        <v-col
                          cols="auto"
                          class="pt-1 mt-0">
                          týdnu
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          kolikátého těhotenství
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.diabetesStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.diabetesPregnancyNumber"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.diabetesStatus != '1'" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Úmrtí plodu
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.deadStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
                <v-col
                  class="mt-0 pt-0"
                  cols="12">
                  <v-row>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          v
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.deadStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.deadWeek"
                            label="Zadejte týden"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.deadStatus != '1'" />
                        </v-col>
                        <v-col
                          cols="auto"
                          class="pt-1 mt-0">
                          týdnu
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pt-0 mt-0"
                      cols="auto">
                      <v-row>
                        <v-col
                          class="pt-1 mt-0"
                          cols="auto">
                          kolikátého těhotenství
                        </v-col>

                        <v-col
                          cols="auto"
                          class="pt-0 mt-0">
                          <VTextFieldWithValidation
                            :rules="form.complicationsPregnancy.deadStatus == '1' ? 'required' : ''"
                            v-model="form.complicationsPregnancy.deadPregnancyNumber"
                            mode="lazy"
                            custom-class="mt-0 pt-0"
                            :disabled="form.complicationsPregnancy.deadStatus != '1'" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="pb-0"
                  cols="auto">
                  Zpomalený růst plodu
                </v-col>
                <v-col
                  class="pb-0"
                  cols="auto">
                  <VRadioWithValidation
                    :disabled="pregnancy === 1"
                    :rules="pregnancy === true ? 'required' : ''"
                    v-model="form.complicationsPregnancy.slowStatus"
                    row
                    custom-class="mt-0 pt-0">
                    <v-radio color="blue lighten-1"
                             label="Ano"
                             :value="1" />
                    <v-radio color="blue lighten-1"
                             label="Ne"
                             :value="2" />
                    <v-radio color="blue lighten-1"
                             label="Nechci uvést"
                             :value="4" />
                  </VRadioWithValidation>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12">
              Porody
            </v-col>
            <v-col
              class="my-0 py-0"
              cols="12">
              <VRadioWithValidation
                :disabled="pregnancy === 1"
                :rules="pregnancy === true ? 'required' : ''"
                v-model="form.countBirths.status"
                row
                custom-class="mt-0 pt-0">
                <v-radio color="blue lighten-1"
                         label="Ano"
                         :value="1" />
                <v-radio color="blue lighten-1"
                         label="Ne"
                         :value="2" />
                <v-radio color="blue lighten-1"
                         label="Nechci uvést"
                         :value="4" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              class="mt-0 pt-0"
              cols="12">
              <v-row>
                <v-col cols="auto">
                  <VTextFieldWithValidation
                    :rules="form.countBirths.status == '1' ? 'required' : ''"
                    v-model="form.countBirths.valueCount"
                    label="Zadejte počet porodů"
                    mode="lazy"
                    custom-class="mt-0 pt-0"
                    :disabled="form.countBirths.status != '1'" />
                </v-col>
                <v-col cols="auto">
                  <VTextFieldWithValidation
                    :rules="form.countBirths.status == '1' ? 'required' : ''"
                    v-model="form.countBirths.valueYear"
                    label="Rok narození dítěte"
                    mode="lazy"
                    custom-class="mt-0 pt-0"
                    :disabled="form.countBirths.status != '1'" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12">
              Spontánní potraty
            </v-col>
            <v-col
              class="my-0 py-0"
              cols="12">
              <VRadioWithValidation
                :disabled="pregnancy === 1"
                :rules="pregnancy === true ? 'required' : ''"
                v-model="form.spontaneousAbortions.status"
                row
                custom-class="mt-0 pt-0">
                <v-radio color="blue lighten-1"
                         label="Ano"
                         :value="1" />
                <v-radio color="blue lighten-1"
                         label="Ne"
                         :value="2" />
                <v-radio color="blue lighten-1"
                         label="Nechci uvést"
                         :value="4" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="auto"
              class="mt-0 pt-0">
              <VTextFieldWithValidation
                :rules="form.spontaneousAbortions.status == '1' ? 'required' : ''"
                v-model="form.spontaneousAbortions.valueWeek"
                label="V jakém týdnu těhotenství"
                mode="lazy"
                custom-class="mt-0 pt-0"
                :disabled="form.spontaneousAbortions.status != '1'" />
            </v-col>
            <v-col
              cols="auto"
              class="mt-0 pt-0">
              <VTextFieldWithValidation
                :rules="form.spontaneousAbortions.status == '1' ? 'required' : ''"
                v-model="form.spontaneousAbortions.valueAge"
                label="V kolika letech"
                mode="lazy"
                custom-class="mt-0 pt-0"
                :disabled="form.spontaneousAbortions.status != '1'" />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12">
              Umělé přerušení těhotenství
            </v-col>
            <v-col
              class="my-0 py-0"
              cols="12">
              <VRadioWithValidation
                :disabled="pregnancy === 1"
                :rules="pregnancy === true ? 'required' : ''"
                v-model="form.abortion.status"
                row
                custom-class="mt-0 pt-0">
                <v-radio color="blue lighten-1"
                         label="Ano, na vlastní žádost"
                         :value="1" />
                <v-radio color="blue lighten-1"
                         label="Ano, z lékařské indikace"
                         :value="3" />
                <v-radio color="blue lighten-1"
                         label="Ne"
                         :value="2" />
                <v-radio color="blue lighten-1"
                         label="Nechci uvést"
                         :value="4" />
              </VRadioWithValidation>
            </v-col>
          </v-row>
        </template>
        <v-col
          cols="auto">
          <v-btn @click="submit()"
                 type="submit"
                 x-large
                 depressed
                 height="68px"
                 class="px-12 white--text"
                 color="blue lighten-1">
            Uložit
          </v-btn>
        </v-col>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheGynecology',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pregnancy: null,
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        spontaneousPregnancy: {
          status: -1,
          value: ''
        },
        complicationsPregnancy: {
          status: -1,
          value: ''
        },
        countBirths: {
          status: -1,
          value: ''
        },
        spontaneousAbortions: {
          status: -1,
          value: ''
        },
        abortion: {
          status: -1,
          value: 'string'
        }
      },
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        pregnancy: (this.pregnancy !== 1),
        spontaneousPregnancy: {
          status: this.form.spontaneousPregnancy.status,
          value: JSON.stringify({
            valueTimes: this.form.spontaneousPregnancy.valueTimes,
            statusAssist: this.form.spontaneousPregnancy.statusAssist,
            valueAssist: this.form.spontaneousPregnancy.valueAssist,
          })
        },
        complicationsPregnancy: {
          status: this.form.spontaneousPregnancy.status,
          value: JSON.stringify({
            bleedingStatus: this.form.complicationsPregnancy.bleedingStatus,
            bleedingWeek: this.form.complicationsPregnancy.bleedingWeek,
            bleedingPregnancyNumber: this.form.complicationsPregnancy.bleedingPregnancyNumber,

            prematureStatus: this.form.complicationsPregnancy.prematureStatus,
            prematureWeek: this.form.complicationsPregnancy.prematureWeek,
            prematurePregnancyNumber: this.form.complicationsPregnancy.prematurePregnancyNumber,

            pressureStatus: this.form.complicationsPregnancy.pressureStatus,
            pressureWeek: this.form.complicationsPregnancy.pressureWeek,
            pressurePregnancyNumber: this.form.complicationsPregnancy.pressurePregnancyNumber,

            diabetesStatus: this.form.complicationsPregnancy.diabetesStatus,
            diabetesWeek: this.form.complicationsPregnancy.diabetesWeek,
            diabetesPregnancyNumber: this.form.complicationsPregnancy.diabetesPregnancyNumber,

            deadStatus: this.form.complicationsPregnancy.deadStatus,
            deadWeek: this.form.complicationsPregnancy.deadWeek,
            deadPregnancyNumber: this.form.complicationsPregnancy.deadPregnancyNumber,

            slowStatus: this.form.complicationsPregnancy.slowStatus
          })
        },
        countBirths: {
          status: this.form.countBirths.status,
          value: JSON.stringify({
            valueCount: this.form.countBirths.valueCount,
            valueYear: this.form.countBirths.valueYear,
          })
        },
        spontaneousAbortions: {
          status: this.form.spontaneousAbortions.status,
          value: JSON.stringify({
            valueWeek: this.form.spontaneousAbortions.valueWeek,
            valueAge: this.form.spontaneousAbortions.valueAge,
          })
        },
        abortion: {
          status: this.form.abortion.status,
          value: 'string'
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/pregnancywomanpart', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/pregnancywomanpart', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.pregnancy = (data.pregnancy === false ? 1 : true);

      this.form = {
        spontaneousPregnancy: {
          status: data.spontaneousPregnancy.status,
          valueTimes: JSON.parse(data.spontaneousPregnancy.value).valueTimes,
          statusAssist: JSON.parse(data.spontaneousPregnancy.value).statusAssist,
          valueAssist: JSON.parse(data.spontaneousPregnancy.value).valueAssist,
        },
        complicationsPregnancy: {
          status: data.spontaneousPregnancy.status,
          bleedingStatus: JSON.parse(data.complicationsPregnancy.value).bleedingStatus,
          bleedingWeek: JSON.parse(data.complicationsPregnancy.value).bleedingWeek,
          bleedingPregnancyNumber: JSON.parse(data.complicationsPregnancy.value).bleedingPregnancyNumber,

          prematureStatus: JSON.parse(data.complicationsPregnancy.value).prematureStatus,
          prematureWeek: JSON.parse(data.complicationsPregnancy.value).prematureWeek,
          prematurePregnancyNumber: JSON.parse(data.complicationsPregnancy.value).prematurePregnancyNumber,

          pressureStatus: JSON.parse(data.complicationsPregnancy.value).pressureStatus,
          pressureWeek: JSON.parse(data.complicationsPregnancy.value).pressureWeek,
          pressurePregnancyNumber: JSON.parse(data.complicationsPregnancy.value).pressurePregnancyNumber,

          diabetesStatus: JSON.parse(data.complicationsPregnancy.value).diabetesStatus,
          diabetesWeek: JSON.parse(data.complicationsPregnancy.value).diabetesWeek,
          diabetesPregnancyNumber: JSON.parse(data.complicationsPregnancy.value).diabetesPregnancyNumber,

          deadStatus: JSON.parse(data.complicationsPregnancy.value).deadStatus,
          deadWeek: JSON.parse(data.complicationsPregnancy.value).deadWeek,
          deadPregnancyNumber: JSON.parse(data.complicationsPregnancy.value).deadPregnancyNumber,

          slowStatus: JSON.parse(data.complicationsPregnancy.value).slowStatus
        },
        countBirths: {
          status: data.countBirths.status,
          valueCount: JSON.parse(data.countBirths.value).valueCount,
          valueYear: JSON.parse(data.countBirths.value).valueYear,
        },
        spontaneousAbortions: {
          status: data.spontaneousAbortions.status,
          valueWeek: JSON.parse(data.spontaneousAbortions.value).valueWeek,
          valueAge: JSON.parse(data.spontaneousAbortions.value).valueAge,
        },
        abortion: {
          status: data.abortion.status,
          value: 'string'
        }
      };
    });
  }
};
</script>
